import React, { Component } from 'react';
import Footer from './components/Footer';

// 手順画像のimport
import winie11 from './images/winie/pic_winie_01.png';
import winie12 from './images/winie/pic_winie_02.png';
import winie13 from './images/winie/pic_winie_03.png';
import winie14 from './images/winie/pic_winie_04.png';
import winie15 from './images/winie/pic_winie_05.png';
import winie16 from './images/winie/pic_winie_06.png';
import winie21 from './images/winie/pic_winie2_01.png';
import winie22 from './images/winie/pic_winie2_02.png';
import winie23 from './images/winie/pic_winie2_03.png';
import winie24 from './images/winie/pic_winie2_04.png';
import winie25 from './images/winie/pic_winie2_05.png';
import winie26 from './images/winie/pic_winie2_06.png';
import winie27 from './images/winie/pic_winie2_07.png';
import winie28 from './images/winie/pic_winie2_08.png';
import winie29 from './images/winie/pic_winie2_09.png';
class AplayIE11 extends Component {
  constructor(props) {
    super(props);
    // 手順１・手順２のタイトルelementの定義
    this.process1 = React.createRef();
    this.process2 = React.createRef();
  }
  componentDidMount = () => {
    document.title = 'IE11で放送内容を聞くには？';
  };

  handleToProcess = (e, id) => {
    e.preventDefault();
    // ヘッダーの高さ
    const headerHeight = 65;

    // 要素の取得
    let targetElmnt = '';
    if (id === 'process1') {
      targetElmnt = this.process1.current; //.value;
    }
    if (id === 'process2') {
      targetElmnt = this.process2.current; //.value;
    }
    const positionTop = targetElmnt.getBoundingClientRect().top;
    window.scrollTo(0, positionTop - headerHeight);
  };

  render = () => {
    return (
      <>
        <header className="titleContent-winie">
          <h1 className="title-winie">IE11で放送内容を聞くには？</h1>
        </header>
        <div className="mainContainer-winie">
          <div className="overview-winie">
            <div className="overview-text-winie">
              <h3>IE11（InternetExplorer11）で放送内容を聞くには、下記の設定を確認・変更してください。</h3>
              <br />
              <b>手順1.「インターネットオプション」→「詳細設定」→「Webページのサウンドを再生する」</b>
              <ol>
                <li>チェックが入っているか確認</li>
                <li>入っていなければ、チェックを入れる</li>
              </ol>
              <span>
                <a
                  href="/"
                  onClick={(e) => {
                    this.handleToProcess(e, 'process1');
                  }}
                >
                  手順1の詳細はこちら
                </a>
              </span>
              <br />
              <b>手順2.「インターネットオプション」→「セキュリティ」→「信頼済みサイト」→ URLを追加</b>
              <ul>
                {/* <li>「サイト」をクリック</li>
                <li>https://machiup.linksmart.jp/ を追加</li> */}
                <li>[手順1]で解決しなかった場合に実施</li>
              </ul>
              <span>
                <a
                  href="/"
                  onClick={(e) => {
                    this.handleToProcess(e, 'process2');
                  }}
                >
                  手順2の詳細はこちら
                </a>
              </span>
              <br />
              <br />
            </div>
          </div>

          <div className="dlContainer-winie">
            <h2>【確認・設定手順】</h2>
            {/* 手順1 */}
            <h3 id="process1" ref={this.process1}>
              手順1. 「インターネットオプション」→「詳細設定」→「Webページのサウンドを再生する」
            </h3>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol>
                  <li>
                    <span className="termText">
                      IE11を立ち上げて、ブラウザ上部のメニュー内の「ツール」をクリックします。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie11} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="2">
                  <li>
                    <span className="termText">
                      「ツール」メニューが開きますので、「インターネットオプション」をクリックします。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie12} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="3">
                  <li>
                    <span className="termText">
                      「インターネットオプション」画面が開きますので、画面上部の「詳細設定」タブをクリックします。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie13} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="4">
                  <li>
                    <span className="termText">
                      「詳細設定」タブ内の「マルチメディア」欄から「Webページのサウンドを再生する」にチェックを入れます。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie14} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="5">
                  <li>
                    <span className="termText">「OK」をクリックして、完了です。</span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie15} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="6">
                  <li>
                    <span className="termText">
                      設定後、再生ボタンを押して、音声が再生されることを確認してください。
                      <br />
                      再生できない場合は、手順2を実施してください。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie16} alt="" className="img-winie" />
              </dd>
            </dl>
          </div>
          <div className="dlContainer-winie">
            {/* 手順2 */}
            <h2>【設定手順】</h2>
            <h3 id="process2" ref={this.process2}>
              手順2.「インターネットオプション」→「セキュリティ」→「信頼済みサイト」→ URLを追加
            </h3>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol>
                  <li>
                    <span className="termText">
                      IE11を立ち上げて、ブラウザ上部のメニュー内の「ツール」をクリックします。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie21} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="2">
                  <li>
                    <span className="termText">
                      「ツール」メニューが開きますので、「インターネットオプション」をクリックします。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie22} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="3">
                  <li>
                    <span className="termText">
                      「インターネットオプション」画面が開きますので、画面上部の「セキュリティ」タブをクリックします。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie23} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="4">
                  <li>
                    <span className="termText">「セキュリティ」タブ内の「信頼済みサイト」をクリックします。</span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie24} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="5">
                  <li>
                    <span className="termText">
                      「このゾーンのセキュリティのレベル」が、【中高】以下になっていることを確認してください。
                      <span className="is-bold">（※）</span>
                      <br />
                      {/* システム管理者によって管理されている場合は、システム管理者に確認してください。 */}
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie29} alt="" className="img-winie" />
                <p>
                  <span className="is-bold">
                    （※）システム管理者によって管理されており、「このゾーンのセキュリティレベル」が【高】から変更できない場合は、システム管理者に確認してください。
                  </span>
                </p>
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="6">
                  <li>
                    <span className="termText">「セキュリティ」タブ内の「サイト」をクリックします。</span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie25} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="7">
                  <li>
                    <span className="termText">
                      「信頼済みサイト」ウィンドウが開きますので、「このWebサイトをゾーンに追加する」の下の入力フォームに以下のURLを入力し、「追加」をクリックします。
                      <br />
                      <span className="is-bold">
                        （注意）既に登録されているWebサイトのURLを削除する必要はありません。
                      </span>
                      <br />
                      https://machiup.linksmart.jp/
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie26} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="8">
                  <li>
                    <span className="termText">
                      「Webサイト」に登録したURLが表示されていることを確認し、「閉じる」をクリックしてください。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie27} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="9">
                  <li>
                    <span className="termText">
                      「インターネットオプション」画面に戻りますので、「OK」をクリックしてください。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie28} alt="" className="img-winie" />
              </dd>
            </dl>
            <dl className="dList-winie">
              <dt className="term-winie">
                <ol start="10">
                  <li>
                    <span className="termText">
                      設定後、再生ボタンを押して、音声が再生されることを確認してください。
                    </span>
                  </li>
                </ol>
              </dt>
              <dd className="description-winie">
                <img src={winie16} alt="" className="img-winie" />
              </dd>
            </dl>
          </div>
        </div>
        <Footer />
      </>
    );
  };
}

export default AplayIE11;
